export default __webpack_public_path__ + "static/media/present.16a88ce4.webp";